export default () => (
  <svg width='192' height='192' viewBox='0 0 192 192' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M96 165.6C134.439 165.6 165.6 134.439 165.6 96C165.6 57.561 134.439 26.4 96 26.4C57.561 26.4 26.4 57.561 26.4 96C26.4 134.439 57.561 165.6 96 165.6ZM168 96C168 135.765 135.765 168 96 168C56.2355 168 24 135.765 24 96C24 56.2355 56.2355 24 96 24C135.765 24 168 56.2355 168 96Z'
      fill='#FFF308'
      fillOpacity='0.2'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M95.6 156C128.958 156 156 128.958 156 95.6C156 62.242 128.958 35.2 95.6 35.2C62.242 35.2 35.2 62.242 35.2 95.6C35.2 128.958 62.242 156 95.6 156ZM159.2 95.6C159.2 130.725 130.725 159.2 95.6 159.2C60.4747 159.2 32 130.725 32 95.6C32 60.4747 60.4747 32 95.6 32C130.725 32 159.2 60.4747 159.2 95.6Z'
      fill='#FFF308'
      fillOpacity='0.6'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M95.6 149.6C125.423 149.6 149.6 125.423 149.6 95.6C149.6 65.7766 125.423 41.6 95.6 41.6C65.7766 41.6 41.6 65.7766 41.6 95.6C41.6 125.423 65.7766 149.6 95.6 149.6Z'
      fill='#FFEC65'
    />
  </svg>
);
